<div class="menu-overlay" [class.active]="isMenuOpen" (click)="closeMenu()"></div>

<div class="fullscreen-menu" [class.active]="isMenuOpen">
  <div class="menu-container container-fluid px-4">
    <button class="menu-back" (click)="closeMenu()">
      <img src="assets/images/arrow-pointing-to-left.png" alt="Seychelles" width="40" height="38" />
    </button>

    <div class="menu-user-section">
      <a *ngIf="currentUser" class="menu-wishlist" (click)="goToWishlist()" title="Wishlist">
        <i class="icon icon-wishlist"></i>
        <span class="wishlist-text">{{ 'Wishlist' | translate }}</span>
      </a>

      <button *ngIf="!currentUser" class="menu-signin" (click)="showLoginDialog()">{{ 'Sign In' | translate }}</button>

      <div *ngIf="currentUser" class="menu-user-dropdown">
        <button class="menu-user-button">
          {{ username }}
          <i class="icon-down-open-big"></i>
        </button>
        <div class="menu-user-dropdown-content">
          <a (click)="showProfileDialog()">{{ 'Profile' | translate }}</a>
          <a (click)="showChangePasswordDialog()">{{ 'Change Password' | translate }}</a>
          <a (click)="logout()">{{ 'Logout' | translate }}</a>
        </div>
      </div>
    </div>

    <div class="menu-header">
      <div class="logo-section">
        <img
          src="assets/images/bannerlogo.png"
          alt="Seychelles"
          class="menu-logo"
          (click)="goToHomepage()"
          style="cursor: pointer"
          loading="lazy"
          decoding="async"
        />
      </div>
      <div class="search-container">
        <div class="search-section">
          <p-autoComplete
            [(ngModel)]="textEnter"
            [placeholder]="'What are you looking for?' | translate"
            [suggestions]="newserachResults"
            (completeMethod)="search($event)"
            minLength="3"
            autocomplete="on"
            immutable="false"
            (onSelect)="goToProductDetails($event)"
            (keypress)="onKeyPress($event)"
            class="menu-search-autocomplete"
            [style]="{ width: '100%' }"
            [dropdown]="false"
          ></p-autoComplete>
          <button class="search-btn" (click)="searchByValue(textEnter)" aria-label="Search">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="2" />
              <path d="M13 13L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="menu-content">
      <div class="menu-grid">
        <div class="menu-section" *ngFor="let section of menuItems" [attr.data-section-id]="section.id">
          <h3 class="section-title">{{ section.title | translate }}</h3>
          <ul class="menu-list">
            <li *ngFor="let item of section.items">
              <a
                [href]="item.fragment ? '/' + item.url + '#' + item.fragment : '/' + item.url"
                (click)="navigateToMenuItem($event, item)"
              >
                {{ item.name | translate }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="map-section d-flex justify-content-center justify-content-md-start">
        <div
          class="island-tooltip"
          [ngClass]="tooltipClass"
          *ngIf="hoveredIsland"
          [style.left.px]="tooltipX"
          [style.top.px]="tooltipY"
        >
          {{ hoveredIsland }}
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" class="interactive-map" viewBox="0 0 466.576 698.959">
          <g id="Group_331" data-name="Group 331" transform="translate(-1387 -336.229)">
            <g
              id="Component_5_4"
              data-name="Component 5 – 4"
              transform="translate(1448.466 353.668)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Bird Island')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Bird Island')"
            >
              <g class="island-shape">
                <path
                  id="Path_157"
                  data-name="Path 157"
                  d="M50.2,19.984c-4.133,1.236-1.643,5.352-2.118,8.369-.233,2.291.45,5.231,2.525,6.424,1.522.752,2.94-1.306,4.427-1.816,2.36-.882,4.954-.182,7.133-1.375,3.865-1.643,5.317-5.2,2.663-8.707-1.772-2.585-5.118-2.654-7.98-2.68-2.162.009-4.461-.787-6.467-.268l-.173.052Z"
                  transform="translate(-18.564 8.59)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="1.05"
                />
              </g>
            </g>
            <g
              id="Component_21_4"
              data-name="Component 21 – 4"
              transform="translate(1537.55 580.267)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Mahe')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Mahe')"
            >
              <g class="island-shape">
                <path
                  id="Path_147"
                  data-name="Path 147"
                  d="M196.265,345.436c-4.007-.7-4.83-5.274-8.081-7.958a10.772,10.772,0,0,0-6.54-2.42c-2.817-.189-6.436.416-8.5-1.853-1.938-2.344-1.8-6.729-.189-9.451,2.183-3.289,4.2-6.947,3.6-11.058-.558-3.421-1.323-7.448-3.44-10.359-1.446-1.843-4.026-2.278-6.21-3.355a12.176,12.176,0,0,1-3.724-2.9c-2.542-2.968-5.756-5.973-8.327-8.894-2.164-2.817-5.614-3.554-9-3.488-3.317-.151-6.351-1.956-9.489-1.314-3.762.926-7.892,2.325-9.111-2.731-.454-1.361-.86-3.025-2.344-3.5-3.147-1.068-8.157,4.017-11.521,3.166-1.456-.425-1.834-2.353-1.125-3.573,1.285-2.259,5.255-2.987,6.257-5.917,1.03-2.4,2.221-4.792,4.612-6.115,3.081-1.654,6.408-3.024,9.669-4.376a36.748,36.748,0,0,1,6.408-1.938,6.192,6.192,0,0,0,3.714-1.786,6.076,6.076,0,0,0,1.021-3.535c.388-4.953-.312-10.406,1.767-14.971.87-1.919,1.8-4.093,3.469-5.368,2.552-1.824,6.644-.293,7.58,2.675,1.04,3.469,1.295,6.871,1.815,10.68.482,3.374-.028,6.956,1.418,10.113a12.384,12.384,0,0,0,1.852,2.76c1.73,2.079,3.223,4.811,4.924,7.051,3.119,4.5,8.951,3.421,13.657,4.093,3.421.539,6.333,2.514,9.357,4.215,2.5,1.38,6.37,2.079,5.973,5.728-.208,2.391-.955,4.877-1.021,7.315-.406,4.546,1.607,9.092,2.656,13.383,2.06,8.147-2.429,12.665,4.3,20.047,1.465,1.749,3.043,3.384,3.478,5.425.577,2.656.066,5.6,1.862,7.9,1.824,2.75,5.236,4.905,6.644,7.968,1.919,4.045,1.068,9.622-4.234,9.385a13.764,13.764,0,0,1-3.781-.406c-3.507-.964-5.784-3.979-9.225-4.593l-.17-.047Z"
                  transform="translate(-111.923 -230.957)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="1.05"
                />
              </g>
            </g>
            <g
              id="Component_6_4"
              data-name="Component 6 – 4"
              transform="translate(1594.023 336.229)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Denis Island')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Denis Island')"
            >
              <g class="island-shape">
                <path
                  id="Path_156"
                  data-name="Path 156"
                  d="M212.315,6.217c-1.634-2.075-.078-5.136,2.473-5.516A14.422,14.422,0,0,1,219.016.64c2.248.233,2.127,2.931,2.1,4.617a19.874,19.874,0,0,1-.13,2.283c-.354,3.856-1.772,5.421-5.006,3.407-1.634-1.089-2.032-3.251-3.554-4.6l-.1-.138Z"
                  transform="translate(-173.417 26.775)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="1.05"
                />
              </g>
            </g>
            <g
              id="Component_7_4"
              data-name="Component 7 – 4"
              transform="translate(1646.495 384.328)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Curieuse')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Curieuse')"
            >
              <g class="island-shape">
                <path
                  id="Path_153"
                  data-name="Path 153"
                  d="M250.21,52.8c-.035-1.046,1.115-1.954,2.352-2.239,2.032-.415,4.211.977,6.32.6,1.185-.078,2.646.64,2.3,1.885-.277,1.5-2.3,2.343-2.931,3.822-.8,2.879-3.562,2.326-5.7.683A5.617,5.617,0,0,1,251.3,55.2c-.3-.821-1.012-1.4-1.089-2.274v-.121Z"
                  transform="translate(-228.014 -24.334)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="0.89"
                />
              </g>
            </g>
            <g
              id="Component_8_4"
              data-name="Component 8 – 4"
              transform="translate(1454.099 473.967)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'North Island')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('North Island')"
            >
              <g class="island-shape">
                <path
                  id="Path_151"
                  data-name="Path 151"
                  d="M58.72,157.045c.34-4.045,4.575-6.682,7.816-8.431,2.023-1,5.69-2.854,7.278-.539.52,1.21-.87,3.11-1.607,4.754-.7,1.456-.681,3.081-1.767,4.121-.955.9-2.344,1.125-3.4,1.853-1.191.766-2.174,1.985-3.61,2.3a4.038,4.038,0,0,1-4.7-3.837v-.208Z"
                  transform="translate(-25.552 -120.05)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="1.05"
                />
              </g>
            </g>
            <g
              id="Component_9_4"
              data-name="Component 9 – 4"
              transform="translate(1690.367 409.471)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Chauve Souris')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Chauve Souris')"
            >
              <g class="island-shape">
                <path
                  id="Path_161"
                  data-name="Path 161"
                  d="M275.521,74.936s-1.513.156-1.712-.648-.4-1.323.19-1.47,0-.389,1.167.017,1.427,0,1.522.571.233.64.052,1.038-1.219.484-1.219.484Z"
                  transform="translate(-273.609 -51.257)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="0.89"
                />
              </g>
            </g>
            <g
              id="Component_10_4"
              data-name="Component 10 – 4"
              transform="translate(1717.853 426.961)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Round Island Praslin')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Round Island Praslin')"
            >
              <g class="island-shape">
                <path
                  id="Path_154"
                  data-name="Path 154"
                  d="M307.488,95.14c.225.372.026,1.357.112,1.885.121.579.225,1.038-.268,1.444a4.579,4.579,0,0,1-3.415.476,2.006,2.006,0,0,1-1.15-2.317c.311-.744,1.392-.847,1.98-1.254.744-.674,1.937-1.254,2.689-.32l.052.078Z"
                  transform="translate(-302.687 -69.751)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="0.89"
                />
              </g>
            </g>
            <g
              id="Component_11_4"
              data-name="Component 11 – 4"
              transform="translate(1761.044 443.359)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Félicité')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Félicité')"
            >
              <g class="island-shape">
                <path
                  id="Path_155"
                  data-name="Path 155"
                  d="M352.557,92.758c.908-.1,1.651-.216,1.928.5a6.451,6.451,0,0,0,1.868,2.94c2.265,1.677-.294,2.931-2.11,2.827-1.167-.138-1.772.726-2.724,1.081a2.368,2.368,0,0,1-3.1-1.842,7.174,7.174,0,0,1,1.133-4.643c.7-1.02,1.807-.666,2.827-.83l.19-.026Z"
                  transform="translate(-348.387 -86.114)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="1.05"
                />
              </g>
            </g>
            <g
              id="Component_13_4"
              data-name="Component 13 – 4"
              transform="translate(1722.95 457.771)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'La Digue')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('La Digue')"
            >
              <g class="island-shape">
                <path
                  id="Path_159"
                  data-name="Path 159"
                  d="M314.7,101.393c-1.833.45-2.5,2.715-3.441,4.159-1.2,2.2-2.585,4.262-2.888,6.848a19.7,19.7,0,0,0-.285,2.421,5.441,5.441,0,0,0,.4,2.5c.752,1.781,3.061,2.68,3.424,4.721.38,1.772.207,3.83,1.012,5.62.83,2.36,3.657,3.977,5.784,2.3a32.8,32.8,0,0,0,3.1-2.905c1.3-1.3,1.5-3.242,2.542-4.695,1.228-1.582,3.407-1.271,3.847-3.26a11.419,11.419,0,0,0-2.715-10.194c-2.161-2.36-4.384-4.963-7.349-6.363-1.15-.623-2.257-1.306-3.277-1.176Z"
                  transform="translate(-308.082 -101.352)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="1.05"
                />
              </g>
            </g>
            <g
              id="Component_14_4"
              data-name="Component 14 – 4"
              transform="translate(1583.092 427.105)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Praslin')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Praslin')"
            >
              <g class="island-shape">
                <path
                  id="Path_152"
                  data-name="Path 152"
                  d="M227.442,72.709c-2.7,2.41-4.081,3.412-3.778,7.618.346,3.469,1.7,6.729,1.989,10.208.19,2.42,1.107,4.716,3.458,5.378,4.064.766,8.378.539,12.156,2.741a13,13,0,0,1,5.974,5.047c1.072,1.909,1.721,4.206,3.424,5.586a16.777,16.777,0,0,0,4.755,2.325c5.309,1.938,10.349,5.113,15.459,7.315,1.107.473,2.689,1.465,3.605.208.77-1.692.579-4.178,2.551-4.99,1.418-.832,3.156-.671,3.813-2.013.865-3.554-6.891-7.334-8.681-10.321-3.043-3.724-.847-10.208,3.778-10.538,2.793-.454,5.1,2.646,7.764,2.75,3.994.038,8.067-4.452,2.715-6.985a14.582,14.582,0,0,1-2.758-1.919c-1.591-1.389-2.775-3.45-4.409-4.036-1.556-.52-3,.577-4.34,1.352-3.441,2.58-7.41,1.266-10.047-1.938-1.089-1.087-2.2-2.07-3.588-2.183-2.378-.265-4.358,1.843-6.658,2.136-1.859.34-3.726-.5-5.741-.709-3.32-.284-6.441-.652-9.026-3.393-4.444-3.79-7.392-12.306-12.321-3.771l-.1.123Z"
                  transform="translate(-157.501 -68.906)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="1.05"
                />
              </g>
            </g>
            <g
              id="Component_15_4"
              data-name="Component 15 – 4"
              transform="translate(1576.532 451.011)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Cousin')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Cousin')"
            >
              <g class="island-shape">
                <path
                  id="Path_160"
                  data-name="Path 160"
                  d="M214.737,104.649c1.366-1.107,4.738-2.749,5.663-.424a13.179,13.179,0,0,1-.346,2.231,2.961,2.961,0,0,1-.6,1.937c-1.141,1.435-3.415,4.3-5.058,1.945a12.958,12.958,0,0,0-1.3-2.257c-.951-1.219.562-2.767,1.53-3.363l.1-.078Z"
                  transform="translate(-155.728 -94.139)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="0.89"
                />
              </g>
            </g>
            <g
              id="Component_16_4"
              data-name="Component 16 – 4"
              transform="translate(1596.209 474.092)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Cousine')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Cousine')"
            >
              <g class="island-shape">
                <path
                  id="Path_162"
                  data-name="Path 162"
                  d="M199.128,120.444c-.38.268-2.144,1.176-1.34,1.8a5.785,5.785,0,0,1,1.634,1.2c.622.726,1.746.908,2.6,1.314.873.432,1.012,1.6,1.591,2.352a2.345,2.345,0,0,0,1.989,1.176,12.633,12.633,0,0,1,3.069.821c1.02.164,1.85-.718.986-1.453a7.937,7.937,0,0,0-1.79-.96,1.871,1.871,0,0,1-1.66-1.548c-.268-1.254.1-2.542-.259-3.735a4.141,4.141,0,0,0-3.164-2.775c-1.366-.19-2.62,1.254-3.528,1.755l-.1.069Z"
                  transform="translate(-174.693 -118.62)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="0.89"
                />
              </g>
            </g>
            <g
              id="Component_17_4"
              data-name="Component 17 – 4"
              transform="translate(1406 544.354)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Silhouette')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Silhouette')"
            >
              <g class="island-shape">
                <path
                  id="Path_150"
                  data-name="Path 150"
                  d="M64.321,192.96a13.975,13.975,0,0,1,4.915,1.352c3.176,1.437,6.143,2.637,8.629,5,3.469,4.357.86,11.389-3.166,14.612-2.429,1.5-8.1,2.079-8.544-1.767-.293-6.815-.709-4.669-6.323-7.126-2.391-1.465-4.206-4.924-3.072-7.429a9.675,9.675,0,0,1,7.372-4.631h.2Z"
                  transform="translate(22.673 -192.96)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="1.05"
                />
              </g>
            </g>
            <g
              id="Component_18_4"
              data-name="Component 18 – 4"
              transform="translate(1585.277 543.929)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Ste. Anne')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Ste. Anne')"
            >
              <g class="island-shape">
                <path
                  id="Path_163"
                  data-name="Path 163"
                  d="M189.193,217.55a14.948,14.948,0,0,1,3.762,1.541c4.782,2.023,4.593,4.575,1.077,8.261a21.257,21.257,0,0,1-7.722,4.593c-1.522-.057-1.172-2.892-1.474-4.026-.255-1.985-1.4-4.149-.293-6.04a25.783,25.783,0,0,1,1.871-2.42c.832-.983,1.522-1.919,2.628-1.909h.142Z"
                  transform="translate(-163.606 -193.884)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="0.69"
                />
              </g>
            </g>
            <g
              id="Component_19_4"
              data-name="Component 19 – 4"
              transform="translate(1603.559 577.817)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Round Island')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Round Island')"
            >
              <g class="island-shape">
                <path
                  id="Path_165"
                  data-name="Path 165"
                  d="M187.733,238.1c.539,2.306-2.514,3.6-4.385,3.2a2.319,2.319,0,0,1-1.512-2.684c.34-.841,1.541-.841,2.145-1.5a6.037,6.037,0,0,1,.775-.709c.662-.236,1.333.312,1.9.6.4.265.907.52,1.049,1Z"
                  transform="translate(-181.761 -228.803)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="0.89"
                />
              </g>
            </g>
            <g
              id="Component_20_4"
              data-name="Component 20 – 4"
              transform="translate(1608.264 587.656)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Cerf Island')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Cerf Island')"
            >
              <g class="island-shape">
                <path
                  id="Path_164"
                  data-name="Path 164"
                  d="M194.175,245.754c1.453-.144,2.317.977,2.974,2.344a6.971,6.971,0,0,1,1.28,3.6,3.07,3.07,0,0,1-3.009,3.485,3.008,3.008,0,0,1-2.957-1.326,6.282,6.282,0,0,0-1.392-1.7c-.821-.555-1.444-.75-2.317-1.285-.925-.473-1.98-1.018-2.015-2.344a5.153,5.153,0,0,1,2.092-4.3c1.582-.576,2.966,1.912,4.548,1.583.2-.021.441-.051.64-.062h.156Z"
                  transform="translate(-186.739 -239.501)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="0.89"
                />
              </g>
            </g>
            <g
              id="Component_22_4"
              data-name="Component 22 – 4"
              transform="translate(1532 638.282)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Therese')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Therese')"
            >
              <g class="island-shape">
                <path
                  id="Path_149"
                  data-name="Path 149"
                  d="M130.513,292.727c-.151.614.038,1.172-.123,1.938a4.81,4.81,0,0,0,.085,2.769,3,3,0,0,0,1.456,1.21,3.03,3.03,0,0,0,2.278-.274c.662-.586.681-1.73.737-2.618.095-.992.775-2.59-.586-2.977a12.485,12.485,0,0,1-2.609-.312c-.473-.142-1-.246-1.219.17l-.038.085Z"
                  transform="translate(-107.376 -292.338)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="0.69"
                />
              </g>
            </g>
            <g
              id="Component_23_4"
              data-name="Component 23 – 4"
              transform="translate(1454 634)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Conception')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Conception')"
            >
              <g class="island-shape">
                <path
                  id="Path_148"
                  data-name="Path 148"
                  d="M114.24,295.247c-1.219,1.144-3.544,5.822-.047,5.35,2.183-.132,4.234.548,5.917-1.106,1.125-.718,1.153-1.616.331-2.7a3.876,3.876,0,0,0-3.554-1.758c-.992-.1-1.881-.388-2.552.132l-.1.085Z"
                  transform="translate(-28.395 -288.195)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="0.69"
                />
              </g>
            </g>
            <g
              id="Component_24_4"
              data-name="Component 24 – 4"
              transform="translate(1780 490)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Frégate')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Frégate')"
            >
              <g class="island-shape">
                <path
                  id="Path_158"
                  data-name="Path 158"
                  d="M406.922,245.244a12.306,12.306,0,0,0-2.788,5.52,7.788,7.788,0,0,1-5.009,5.1c-4.48,1.692-7.6-.01-10.387-3.611-2.2-2.618-5.359-4.508-7.013-7.6-2.911-5.274,2.769-10.444,7.977-10.463,4.5-.529,9.158,1.777,12.674,4.083,2.1,1.673,7.325,3.478,4.65,6.824Z"
                  transform="translate(-369.127 -207.863)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="1.05"
                />
              </g>
            </g>
            <g
              id="Component_25_4"
              data-name="Component 25 – 4"
              transform="translate(1446 769)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Desroches')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Desroches')"
            >
              <g class="island-shape">
                <path
                  id="Path_167"
                  data-name="Path 167"
                  d="M32.664,473.548a14.39,14.39,0,0,1,3.525-1.3c1.73-.189,3.629-.681,4.678-2.3.633-.832,1.115-1.89,2.1-2.316,1.049-.482,2.788-.284,4.083-.747,1.314-.4,2.108-1.616,3.232-2.325.926-.624,2.221-.737,3.1-1.276,1.248-.747,1.285-2.372,2.4-3.346,1.38-1.3,2.609-2.987-.425-2.552-1.815.359-3.44,1.607-4.971,2.552a23.685,23.685,0,0,0-2.429,1.7,19.184,19.184,0,0,1-3.563,2.5,17.035,17.035,0,0,1-2.533.87c-2.656.822-5.954.8-8.346,2.438-1.38.907-1.645,2.552-1.72,4.074a10.713,10.713,0,0,0-.095,1.616c.019.265.057.454.2.529a.993.993,0,0,0,.728-.085l.047-.019Z"
                  transform="translate(-15.971 -432.106)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="1.19"
                />
              </g>
            </g>
            <g
              id="Component_27_4"
              data-name="Component 27 – 4"
              transform="translate(1387 804)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Poivre')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Poivre')"
            >
              <g class="island-shape">
                <path
                  id="Path_166"
                  data-name="Path 166"
                  d="M76.717,478.13c.165.274-.617.177-1.521.366a1,1,0,0,1-.289,1.266h-.818l-1.156-.385-1.09,1.086c-1.451,1.031,1.009,3.988-.727,3.635-1.289-.475-2.355-2.993-1.867-4.336.488-1.166.378-1.508,1.3-2.145,1.167-1.058,4.907-1.088,6.087.377l.081.122Z"
                  transform="translate(-20.335 -470.508)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="0.89"
                />
              </g>
            </g>
            <g
              id="Component_28_4"
              data-name="Component 28 – 4"
              transform="translate(1665 846)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Platte')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Platte')"
            >
              <g class="island-shape">
                <path
                  id="Path_168"
                  data-name="Path 168"
                  d="M264.748,541.682s1.73.832,1.871.9l1.427.671a8.975,8.975,0,0,1,1.474,1.37,4.944,4.944,0,0,1,1.068,3.62c0,2.108.1,4.546.1,4.546a4.818,4.818,0,0,1-.558,1.985,32.661,32.661,0,0,0-1.408,3.818l-.321,1.267a4.83,4.83,0,0,1-1.172.52,3.79,3.79,0,0,0-1.1.539,1.252,1.252,0,0,1-.936.321c-.444-.095-.6-.293-.775-1.673s.614-1.531.293-3.591a12.317,12.317,0,0,0-1.767-4.2s-1.531-4.055-1.314-5.6.3-4.272,1.352-4.65a1.79,1.79,0,0,1,1.663.094l.1.076Z"
                  transform="translate(-247.583 -513.716)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="0.6"
                />
              </g>
            </g>
            <g
              id="Component_29_4"
              data-name="Component 29 – 4"
              transform="translate(1409 924)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Cosmoledo')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Cosmoledo')"
            >
              <g class="island-shape">
                <path
                  id="Path_170"
                  data-name="Path 170"
                  d="M24.872,620.795a6.022,6.022,0,0,0-2.892.18c-2.079.463-4.168-.577-5.557,0a14.108,14.108,0,0,1-4.055.69,8.721,8.721,0,0,0-2.665.492c-.926.378-.227.435-1.389,2.287s0,0-1.5,1.04-.577.926-1.389,1.739-1.5.926-2.2,2.9,0,2.193,0,2.193C1.479,634.859.326,639.726.44,646.664s3.128,5.784,4.395,4.858,3.355-9.716,4.282-12.155,3.469.227,6.021,0,.113-1.04-.577-3.006,1.04-1.153,4.395-3.005-.463-1.966,1.276-3.818,0-1.5-.113-1.966-1.04-.926-1.389-1.153-.463-.463,0-1.276,1.276-.813,1.966-1.616,2.079-.577,2.779-.681c0,0,.35.331,1.389-.01a9.41,9.41,0,0,1,2.779-.463c.7,0,1.852-.69,0-1.04s-2.779-.529-2.779-.529Z"
                  transform="translate(22.744 -596.068)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="0.89"
                />
              </g>
            </g>
            <g
              id="Component_30_4"
              data-name="Component 30 – 4"
              transform="translate(1529.478 964.403)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Grande ile')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Grande ile')"
            >
              <g class="island-shape">
                <path
                  id="Path_171"
                  data-name="Path 171"
                  d="M119.277,670.872s5.094.69,4.745,3.242-1.153,10.992-1.5,12.155-6.484,10.529-10.642,11.455-9.026,2.883-8.45,5.548,5.671,2.079,8.676,0,13.884-13.071,15.623-20.595,3.355-7.06,3.469-9.489-.227-3.818-2.542-3.242-2.779,1.04-3.7.577-2.779-2.779-3.818-2.316S118.465,668.093,119.277,670.872Z"
                  transform="translate(-103.381 -639.073)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="0.89"
                />
                <path
                  id="Path_172"
                  data-name="Path 172"
                  d="M130.041,640.594c.35.227,3.355,3.705,3.242,5.9s-2.892,7.523-1.616,8.8,2.079,3.005,2.542,1.276a67.323,67.323,0,0,0,1.389-7.618,37.577,37.577,0,0,0-1.5-6.625c-.813-2.647-2.316-4.5-3.355-4.849s-2.779.35-1.739,1.739l1.04,1.389Z"
                  transform="translate(-104.768 -637.386)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="0.89"
                />
              </g>
            </g>
            <g
              id="Component_31_4"
              data-name="Component 31 – 4"
              transform="translate(1435 1004)"
              class="island-group"
              (mouseenter)="onIslandHover($event, 'Ile Sud Ouest')"
              (mousemove)="onIslandMove($event)"
              (mouseleave)="onIslandLeave()"
              (click)="onIslandClick('Ile Sud Ouest')"
            >
              <g class="island-shape">
                <path
                  id="Path_169"
                  data-name="Path 169"
                  d="M34.72,705.211s3.54,3.9,7.62,3.9,6.024-3.012,9.216-1.944a44.17,44.17,0,0,0,9.744,1.944,13.071,13.071,0,0,0,7.44-1.944c1.764-1.236.708-1.416,3.9-1.068s1.236.888,4.968,0,3.192-.36,5.5-.888,4.788-.708,1.236,1.068-3.54,1.284-9.036,2.856-3.192,1.212-10.1,2.28-4.416,1.944-9.384,1.776-4.08-1.776-7.98-1.944-5.844.888-9.036,0-4.968-2.124-5.316-3.54-1.236-2.832,1.236-2.484Z"
                  transform="translate(-16.319 -682.459)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="0.89"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>

    <div class="menu-footer">
      <app-new-language-selector [showLabel]="false"></app-new-language-selector>
      <div class="theme-toggle-wrapper">
        <span class="theme-label">{{ 'Theme' | translate }}:</span>
        <button class="theme-toggle-button" (click)="toggleTheme()">
          {{ ((currentTheme$ | async) === 'dark' ? 'Dark' : 'Light') | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
